import http from './http';

export async function getKpiDashboard(params) {
  const { data } = await http.get('/api/admin/kpi/dashboard', { params });
  return data;
}

export async function pageKpiCases(params) {
  const { data } = await http.get('/api/admin/kpi/cases/page', { params });
  return data;
}

export async function getKpiCaseDetail(caseNo) {
  const { data } = await http.get(`/api/admin/kpi/cases/${caseNo}`);
  return data;
}
